// @flow
/* globals document, window */
import React from "react";

import { GlobalProvider } from "../common/GlobalContext";
import CommunityInfo from "./CommunityInfo";

const Container = (props: Object) => {
  return (
    <GlobalProvider {...props}>
      <CommunityInfo {...props} />
    </GlobalProvider>
  );
};

export default Container;
